import React, { ChangeEvent, FocusEvent } from 'react';
import { CommonTextInputProps } from '../../../types/common';

export const TextboxTestId = 'textbox-input';

type TextBoxProps = CommonTextInputProps;

const Textbox: React.FC<TextBoxProps> = ({
  autoFocus = false,
  name,
  type = 'text',
  inputMode,
  pattern,
  min,
  max,
  step,
  hasErrors,
  className = '',
  autoComplete,
  defaultValue,
  register,
  disabled,
  maxLength,
  readOnly,
  value,
  onBlur,
  onChange,
  onFocus,
  onKeyDown,
}: TextBoxProps) => {
  const classes = `${className}
    border-1-half rounded
    border-transparent outline-none
    focus:border-[color:var(--form-accent-color)] ${
      hasErrors ? 'input-error-border' : ''
    }`;

  if (!register) {
    return (
      <input
        id={name}
        name={name}
        type={type}
        inputMode={inputMode}
        pattern={pattern}
        min={min}
        max={max}
        maxLength={maxLength}
        disabled={disabled}
        readOnly={readOnly}
        step={step}
        className={classes}
        onKeyDown={onKeyDown}
        onFocus={onFocus}
        data-testid={TextboxTestId}
        autoCorrect="off"
        autoComplete={autoComplete}
        defaultValue={defaultValue}
        value={value}
        // eslint-disable-next-line jsx-a11y/no-autofocus
        autoFocus={autoFocus}
        onChange={onChange}
        onBlur={onBlur}
      />
    );
  }

  const {
    onChange: rhfOnChange,
    onBlur: rhfOnBlur,
    ...rest
  } = register?.(name) ?? {};

  const handleOnChange = (event: ChangeEvent<HTMLInputElement>): void => {
    rhfOnChange?.(event);
    onChange?.(event);
  };

  const handleOnBlur = (event: FocusEvent<HTMLInputElement>): void => {
    rhfOnBlur?.(event);
    onBlur?.(event);
  };

  return (
    <input
      id={name}
      type={type}
      inputMode={inputMode}
      pattern={pattern}
      min={min}
      max={max}
      maxLength={maxLength}
      disabled={disabled}
      readOnly={readOnly}
      step={step}
      className={classes}
      onKeyDown={onKeyDown}
      onFocus={onFocus}
      data-testid={TextboxTestId}
      autoCorrect="off"
      autoComplete={autoComplete}
      defaultValue={defaultValue}
      // eslint-disable-next-line jsx-a11y/no-autofocus
      autoFocus={autoFocus}
      onChange={handleOnChange}
      onBlur={handleOnBlur}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...rest}
    />
  );
};
export default Textbox;
